import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ALLOWED_ROLES = ['admin', 'agent', 'livreur', 'user'];

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
  const effectiveUser = user || storedUser;

  if (!effectiveUser || !localStorage.getItem('token')) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!ALLOWED_ROLES.includes(effectiveUser.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
